<template>
  <div class="container page victoria-record-page notice-page">
    <div class="header">
      <van-nav-bar :title="$t('my.sys_notice')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh"  pulling-text=" " loosing-text=" " loading-text="...">
          <div class="listItem" v-for="(v,key) in notice" :key="key">
            <div class="listTitle">{{ v.name }}</div>
            <div class="listContent html"><p class="listContentText">{{ v.text }}<br></p></div>
            <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice:{},
      loading: false,
      finished: false,
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getNoticeList(){
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res=>{
        console.log(res);
        this.notice = res.data
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  },
  created() {
    this.getNoticeList();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 0.93333rem;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 0.93333rem;
}
.container .content {
  height: calc(100% - 0.53333rem);
  overflow: auto;
}
.container .content .listItem{
  margin-bottom: 0.53333rem;
  padding: 0.53333rem 0.23333rem 0;
  position: relative;
  color: #000;
  background-color: #fff;
}
.container .content .listItem .listTitle{
  font-size: .4333rem;
}
.container .content .listItem .listContent{
  border-bottom: 0.05333rem solid #f2f2f5;
  font-size: 0.36667rem;
  color: #000 !important;
}
.container .content .listItem .listTime{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 1.86667rem;
}
.container .content .listItem .listTime .listTimeText {
  color: #656566;
  font-size: 0.4rem;
}
.listContentText{
    padding: 0 0 !important;
    margin-top: 2vw;
    font-size: 0.3rem;
    color: #000;
}
</style>
